import axios from 'axios'
import { Message } from 'element-ui'
import { MessageBox } from 'element-ui'
// import { getToken } from './auth'
// import { getSessionToken } from '@shopify/app-bridge-utils'
import store from '@/store'
// 创建axios实例
// axios.defaults.headers.withCredentials =true;

const service = axios.create({
  baseURL: 'https://markplace.sendfromchina.com/platform/shopify-app/', // api 的 base_url  测试
  // baseURL: 'https://markplace.sfcservice.com/platform/shopify-app/', // api 的 base_url  测试
  // timeout: 5000, // 请求超时时间
  withCredentials: true,
  responseType: 'json'

})
console.log('ssss', store.getters.token)
// request拦截器
service.interceptors.request.use(
  config => {
    let systemCode
    if (systemCode) {
      config.headers['systemCode'] = systemCode
    }
    if (store.getters.token) {
      config.headers['Authorization'] = store.getters.token
    }
    return config
    // return getSessionToken(window.app).then(token => {
    //   let systemCode
    //   if (systemCode) {
    //     config.headers['systemCode'] = systemCode
    //   }
    //   config.headers['Authorization'] = `Bearer ${token}`
    //   return config
    // })
  },
  error => {
    console.log(error)
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    /**
     * code为非'000000'是抛错
     */
    const res = response.data
    console.log(response)
    if (res.ask === 1) {
      return response
    } else if (res.ask == 0) {
      if (res.msg == 'need login') {
        console.log(response.config.url)
        if (response.config.url != 'https://markplace.sendfromchina.com/platform/shopify-app/check-login' && response.config.url != 'https://markplace.sendfromchina.com/platform/shopify-app/is-verify') {
          // if(response.config.url!="https://markplace.sfcservice.com/platform/shopify-app/check-login"){
          MessageBox.confirm(
            'The current user has expired. Please log in again.',
            'Tips',
            {
              confirmButtonText: 'confirm',
              cancelButtonText: 'cancel',
              type: 'warning'
            }
          ).then(() => {
            if (window.top == window.self) {
              // this.show = false;
              var path =
                    'https://' +
                    store.getters.shopTokenuserparam.shop +
                    '/admin/apps/' +
                    response.data.apps
              window.location.assign(path)
            } else {
              var path =
                    'https://' +
                    store.getters.shopTokenuserparam.shop +
                    '/admin/apps/' +
                    response.data.apps
              window.top.location.href = path
            }
          })
        }
      } else if (res.msg != 'The rule is not found. ' && res.msg != '找不到你要修改的规则。' && res.msg != 'No Data' && res.msg != 'need Install. ') {
        console.log(res.msg)
        Message({
          message: res.msg,
          type: 'error',
          duration: 3000,
          customClass: 'zZindex'
        })
      }
      return response
    } else {
      return response
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 3000
    })
    // return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/components/utils/request.js